<template>
  <div class="sub-navbar">
    <div class="nav-item" v-for="item in (menu.children || []).filter(item => item.display == 1)" :key="item.id">
      <div @click="handleClick(item)" class="first-child pointer">
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecondNavbar',
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    // handleLink(row) {
    //   if(row.type == 2) {
    //     if (row.customized == 1) { // 左右单页
          
    //     } else if (row.customized == 2) { // 上下单页
          
    //     } else if (row.customized == 3) { // 父子单页
    //       this.$router.push(`${this.menu.path}/parentChild?id=${row.id}`)
    //     }
    //   } else {

    //   }
    // }
  },
}
</script>

<style lang="scss" scoped>
.sub-navbar {
  overflow: hidden;
  font-size: 1.1rem;
  padding: 10px 0;
  .nav-item {
    color: #fff;
    .first-child {
      .name {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        font-weight: 600;
        line-height: 3;
        padding: 0 10px;
        text-align: center;
      }
      .desc {
        font-size: 13px;
        color: #999;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .link-box {
      font-size: 1rem;
      line-height: 1.8;
      .link {
        cursor: pointer;
        margin: 0.3rem 0;
        font-size: 1rem;
        color: #222;
        &:hover {
          color: #1a71d8;
        }
      }
    }
    &:hover {
      background-color: #005EFF;
    }
  }
}
</style>
